<!--通知栏-->
<template>
    <div>
        <van-notice-bar v-for="item in noticeList"
                mode="closeable"
                :color="item.fontColor"
                :background="item.bkgColor"
                left-icon="like-o"
                @close="closeNotice(item.noticeId)"
        >
            {{item.showInfo}}
        </van-notice-bar>
    </div>

</template>

<script>
    import * as MyApi from '../../api/URLApiAddr.js'
    export default {
        name: "FinNoticeInfo",
        data() {
            return {
                noticeList: []
            }
        },
        mounted() {
            this.initNotice()
        },
        methods: {
            initNotice(){
                let params = {}
                this.$axios.post(MyApi.QRY_NOTICE_INFO,params/*,options*/)
                // 请求成功后
                    .then((data) => {
                        if('200' == data.code){
                            this.noticeList = data.data
                        }

                    })
                    .catch((err) => {

                    })
            },
            closeNotice(noticeId){
                this.$dialog.confirm({
                    title: '关闭通知',
                    message: '关闭后,该通知不再提示,确认不？'
                }).then(() => {
                    let params = {"noticeId":noticeId}
                    this.$axios.post(MyApi.CLOSE_NOTICE_INFO,params/*,options*/)
                        .then((response) =>  {
                            let code = response.code;
                            if(code == '200'){
                                this.$toast.success(response.msg);
                            }
                        })
                        .catch((err) =>{
                            this.$toast.fail("关闭异常"+err);
                        })

                }).catch(() => {

                });


            }
        }
    }
</script>

<style scoped>

</style>
